import { useComponentTranslation } from '@tebuto/functions/translation.components'
import { BookingWidgetContext } from '@tebuto/widget/booking-widget/context'
import { useContext, useMemo } from 'react'
import { BookingCalendarContext } from '../context'
import FilterMultiSelect from './FilterMultiSelect'

export default function CategoryFilters() {
    const { t } = useComponentTranslation()
    const { selectedCategoryIDs, setSelectedCategoryIDs, fixedCategoryId, availableCategoryIDs } =
        useContext(BookingCalendarContext)
    const { configuredCategories } = useContext(BookingWidgetContext)

    // Use configured categories if provided, otherwise hide the filter
    const sortedCategories = useMemo(() => {
        if (!configuredCategories || configuredCategories.length === 0) {
            return []
        }
        const availableCategoryIdSet = new Set(availableCategoryIDs)
        const seen = new Set<number>()
        return [...configuredCategories]
            .filter((category) => availableCategoryIdSet.has(category.id))
            .filter((category) => {
                if (seen.has(category.id)) {
                    return false
                }
                seen.add(category.id)
                return true
            })
            .sort((a, b) => a.name.localeCompare(b.name))
    }, [configuredCategories, availableCategoryIDs])

    const options = useMemo(
        () =>
            sortedCategories.map((category) => ({
                id: category.id,
                name: category.name
            })),
        [sortedCategories]
    )

    // Hide category filter when a fixed category is set (e.g., move booking flow)
    // or when no categories are configured
    if (fixedCategoryId !== undefined || sortedCategories.length < 1) {
        return null
    }

    return (
        <FilterMultiSelect
            label={t('booking.bookingCalendar.categories')}
            options={options}
            selectedIds={selectedCategoryIDs}
            onSelectionChange={setSelectedCategoryIDs}
            placeholder={t('booking.bookingCalendar.selectCategories')}
        />
    )
}
